/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * To add polyfills, add them to this file and then add them to the POLYFILLS array in angular.json.
 */

// Zone JS is required by default for Angular itself.
import 'zone.js';  // Included with Angular CLI.

// Polyfills for SVG and Canvas support in older browsers or Chrome-specific issues
if (typeof SVGElement !== 'undefined' && typeof SVGElement.prototype !== 'undefined') {
  // Ensure SVG elements are properly supported
  if (!SVGElement.prototype.contains) {
    SVGElement.prototype.contains = function(node: Node | null): boolean {
      if (!node) return false;
      return this === node || !!(this.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    };
  }
}

// Polyfill for CanvasRenderingContext2D if needed
if (typeof HTMLCanvasElement !== 'undefined' && typeof CanvasRenderingContext2D !== 'undefined') {
  // Ensure canvas context is available
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    console.warn('Canvas 2D context not available. Charts may not render properly.');
  }
}

// Polyfill for requestAnimationFrame if not available
if (typeof window !== 'undefined' && !window.requestAnimationFrame) {
  window.requestAnimationFrame = function(callback: FrameRequestCallback): number {
    return setTimeout(callback, 16) as any;
  };
}

// Polyfill for performance.now if not available
if (typeof window !== 'undefined' && !window.performance) {
  (window as any).performance = {
    now: function(): number {
      return Date.now();
    }
  };
}
